import { FC } from 'react';

import { ICartItem } from 'types/ICart';
import { IProduct } from 'types/IProduct';

import { Product } from './Product';
import { Wrapper } from './styles';

type TProducts = {
  items?: ICartItem[];
  addOneItem: (product: ICartItem | IProduct) => void;
  removeOneItem: (product: ICartItem | IProduct) => void;
  onClickItem: (product: IProduct) => void;
  removeItem: (product: ICartItem) => void;
  changeItemQuantity: (product: ICartItem, quantity: number) => void;
};

export const Products: FC<TProducts> = ({
  items,
  addOneItem,
  removeOneItem,
  onClickItem,
  removeItem,
  changeItemQuantity,
}) => {
  return (
    <Wrapper>
      {items?.map((item) => (
        <Product
          key={item._id}
          item={item}
          addOneItem={addOneItem}
          removeOneItem={removeOneItem}
          onClickItem={onClickItem}
          removeItem={removeItem}
          changeItemQuantity={changeItemQuantity}
        />
      ))}
    </Wrapper>
  );
};
